<template>
	<div class="add-menu">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="nodeData.id ? $t('addMenu.edit') : $t('addMenu.add')"
			:visible.sync="dialogAddMenu"
			width="40%"
			top="9vh"
			@open="open"
			:close-on-click-modal="false"
			@closed="closed"
			:before-close="handleClose">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					ref="menuData"
					:model="nodeData"
					:label-position="labelPosition"
					v-loading="loading"
					:rules="rules"
					label-width="80px">
					<el-row :gutter="20">
						<el-col :span="24" class="pd-r">
							<el-form-item :label="$t('addMenu.top')">
								<treeselect
									v-model="selectId"
									:show-count="true"
									:placeholder="$t('addMenu.pTop')"
									:options="menuList"></treeselect>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24" class="pd-r">
							<el-form-item :label="$t('addMenu.menuType')" prop="type">
								<el-radio-group v-model="nodeData.type" size="medium">
									<el-radio border label="0">{{ $t("addMenu.mq") }}</el-radio>
									<el-radio border label="1">{{ $t("addMenu.mw") }}</el-radio>
									<el-radio border label="2">{{ $t("addMenu.me") }}</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<div class="menu-scroll">
						<el-row
							:gutter="20"
							v-for="(item, index) in nodeData.names"
							:key="item.key"
							class="b-t-m">
							<el-col :span="24">
								<el-form-item
									:label="$t('addMenu.name')"
									:prop="'names.' + index + '.name'">
									<!--  :rules="{
                                    required: true, message: $t('addMenu.rName'), target: 'blur', pattern: '^[\u4e00-\u9fa5a-zA-Z ]+$'
                                    }" -->
									<el-input
										v-model="item.name"
										:placeholder="$t('addMenu.pName')"
										class="input-with-select">
										<el-select
											style="width: 140px"
											v-model="item.lang"
											:key="itemKey"
											:no-data-text="$t('common.noData')"
											:no-match-text="$t('common.noData')"
											@change="changeMenu"
											slot="prepend"
											:placeholder="$t('common.select')">
											<el-option
												v-for="item in langList"
												:key="item.id"
												:label="item.label"
												:value="item.value"
												:disabled="item.disabled">
											</el-option>
										</el-select>
										<el-button
											slot="append"
											icon="el-icon-plus"
											v-if="index === 0"
											@click="addLang"
											>Add language</el-button
										>
										<el-button
											slot="append"
											icon="el-icon-delete"
											v-else
											@click="delLang(item)"
											>Delete</el-button
										>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<el-row :gutter="20" v-if="nodeData.type === '1'">
						<el-col :span="6">
							<el-form-item
								:label="$t('addMenu.authority')"
								:prop="isMenuProp ? '' : 'authority'">
								<el-input
									v-model="nodeData.authority"
									:placeholder="$t('addMenu.pAuthority')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6" class="pd-r">
							<el-form-item
								:label="$t('addMenu.component')"
								:prop="isMenuProp ? '' : 'component'">
								<el-input
									v-model="nodeData.component"
									:placeholder="$t('addMenu.pComponent')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6" class="pd-r">
							<el-form-item
								:label="$t('addMenu.menuUrl')"
								:prop="isMenuProp ? '' : 'url'">
								<el-input
									v-model="nodeData.url"
									:placeholder="$t('addMenu.pMenuUrl')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item
								:label="$t('addMenu.path')"
								:prop="isMenuProp ? '' : 'path'">
								<el-input
									v-model="nodeData.path"
									:placeholder="$t('addMenu.pPath')"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row
						:gutter="20"
						v-if="nodeData.type === '2' || nodeData.type === '3'">
						<el-col :span="12">
							<el-form-item
								:label="$t('addMenu.authority')"
								:prop="isMenuProp ? '' : 'authority'">
								<el-input
									v-model="nodeData.authority"
									:placeholder="$t('addMenu.pAuthority')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12" class="pd-r">
							<el-form-item
								:label="$t('addMenu.menuUrl')"
								:prop="isMenuProp ? '' : 'url'">
								<el-input
									v-model="nodeData.url"
									:placeholder="$t('addMenu.pMenuUrl')"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20" class="m-r-t">
						<el-col
							:span="24"
							v-if="nodeData.type !== '2' && nodeData.type !== '3'"
							class="pd-r">
							<el-form-item
								:label="$t('addMenu.icon')"
								:prop="isMenuProp ? 'icon' : ''">
								<el-popover
									placement="bottom-start"
									width="400"
									trigger="focus"
									popper-class="popper-icon"
									v-model="visible">
									<div class="icon-picker-scroll">
										<ul class="icon-menu-list">
											<li
												v-for="item in iconList"
												:key="item.id"
												:title="item.text"
												@click="addIcon(item.icon)">
												<i :class="item.icon"></i>
											</li>
										</ul>
									</div>
									<el-input
										v-model="nodeData.icon"
										:prefix-icon="nodeData.icon"
										slot="reference"
										@click="visible = !visible"
										:placeholder="$t('addMenu.pIcon')"></el-input>
								</el-popover>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col
							:span="12"
							v-if="nodeData.type !== '2' && nodeData.type !== '3'">
							<el-form-item :label="$t('addMenu.state')" prop="type">
								<el-radio-group v-model="nodeData.enabled" size="medium">
									<el-radio border label="1">{{ $t("addMenu.show") }}</el-radio>
									<el-radio border label="0">{{ $t("addMenu.hide") }}</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item
								:label="$t('addMenu.sort')"
								prop="sort"
								class="pd-r">
							<el-input-number
								v-model="nodeData.sort"
								controls-position="right"
								:min="1"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialogAddMenu">{{
					$t("common.cancel")
				}}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="addMenu('menuData')"
					>{{ $t("common.definite") }}</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
	name: "AddMenu",
	components: { Treeselect },
	data() {
		return {
			menu: {},
			topMenu: null,
			visible: false,
			iconList: [
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "1",
					icon: "iconfont icon-rili",
					text: "日历",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "2",
					icon: "iconfont icon-tiaoshi",
					text: "调试",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "3",
					icon: "iconfont icon-changjingguanli",
					text: "场景管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "4",
					icon: "iconfont icon-fenxiangfangshi",
					text: "分享方式",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "5",
					icon: "iconfont icon-bianji",
					text: "编辑",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "6",
					icon: "iconfont icon-guanlianshebei",
					text: "关联设备",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "7",
					icon: "iconfont icon-guanfangbanben",
					text: "官方版本",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "8",
					icon: "iconfont icon-gongnengdingyi",
					text: "功能定义",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "9",
					icon: "iconfont icon-jichuguanli",
					text: "基础管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "10",
					icon: "iconfont icon-jishufuwu",
					text: "技术服务",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "11",
					icon: "iconfont icon-hezuohuobanmiyueguanli",
					text: "合作伙伴密钥",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "12",
					icon: "iconfont icon-ceshishenqing",
					text: "测试申请",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "13",
					icon: "iconfont icon-jiedianguanli",
					text: "节点管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "14",
					icon: "iconfont icon-jinggao",
					text: "警告",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "15",
					icon: "iconfont icon-peiwangyindao",
					text: "配网引导",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "16",
					icon: "iconfont icon-renjijiaohu",
					text: "人机交互",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "17",
					icon: "iconfont icon-shiyongwendang",
					text: "使用文档",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "18",
					icon: "iconfont icon-shebeikaifa",
					text: "设备开发",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "19",
					icon: "iconfont icon-quanxianshenpi",
					text: "权限审批",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "20",
					icon: "iconfont icon-yishouquan",
					text: "已授权",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "21",
					icon: "iconfont icon-tianshenpi",
					text: "提案审批",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "22",
					icon: "iconfont icon-shujukanban",
					text: "数据看板",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "23",
					icon: "iconfont icon-yingyongguanli",
					text: "应用管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "24",
					icon: "iconfont icon-yibiaopan",
					text: "仪表盘",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "25",
					icon: "iconfont icon-zhanghaoquanxianguanli",
					text: "账号权限管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "26",
					icon: "iconfont icon-yuanquyunwei",
					text: "园区运维",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "27",
					icon: "iconfont icon-zhunbeiliangchan",
					text: "准备量产",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "28",
					icon: "iconfont icon-jizhanguanli",
					text: "基站管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "29",
					icon: "iconfont icon-guanbi",
					text: "关闭",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "30",
					icon: "iconfont icon-zidingyi",
					text: "自定义",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "31",
					icon: "iconfont icon-xiajiantou",
					text: "下箭头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "32",
					icon: "iconfont icon-shangjiantou",
					text: "上箭头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "33",
					icon: "iconfont icon-icon_loading",
					text: "加载中",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "34",
					icon: "iconfont icon-icon_renwujincheng",
					text: "任务进度",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "35",
					icon: "iconfont icon-icon_rukou",
					text: "入口",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "36",
					icon: "iconfont icon-icon_yiwenkongxin",
					text: "疑问空心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "37",
					icon: "iconfont icon-icon_fabu",
					text: "发布",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "38",
					icon: "iconfont icon-icon_tianjia",
					text: "添加",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "39",
					icon: "iconfont icon-icon_yulan",
					text: "预览",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "40",
					icon: "iconfont icon-icon_zhanghao",
					text: "账号",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "41",
					icon: "iconfont icon-icon_wangye",
					text: "网页",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "42",
					icon: "iconfont icon-icon_shezhi",
					text: "设置",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "43",
					icon: "iconfont icon-icon_baocun",
					text: "保存",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "44",
					icon: "iconfont icon-icon_yingyongguanli",
					text: "应用管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "45",
					icon: "iconfont icon-icon_shiyongwendang",
					text: "使用文档",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "46",
					icon: "iconfont icon-icon_bangzhuwendang",
					text: "帮助文档",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "47",
					icon: "iconfont icon-biaodanzujian-shurukuang",
					text: "输入框",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "48",
					icon: "iconfont icon-biaodanzujian-biaoge",
					text: "表格",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "49",
					icon: "iconfont icon-biaodanzujian-xialakuang",
					text: "下拉框",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "50",
					icon: "iconfont icon-tubiao-bingtu",
					text: "饼图",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "51",
					icon: "iconfont icon-biaodanzujian-anniu",
					text: "按钮",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "52",
					icon: "iconfont icon-gongyezujian-yibiaopan",
					text: "仪表盘",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "53",
					icon: "iconfont icon-tubiao-qiapian",
					text: "卡片",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "54",
					icon: "iconfont icon-gongyezujian-zhishideng",
					text: "指示灯",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "55",
					icon: "iconfont icon-tubiao-zhexiantu",
					text: "折线图",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "56",
					icon: "iconfont icon-xingzhuang-juxing",
					text: "矩形",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "57",
					icon: "iconfont icon-xingzhuang-jianxing",
					text: "箭头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "58",
					icon: "iconfont icon-gongyezujian-kaiguan",
					text: "开关",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "59",
					icon: "iconfont icon-tubiao-zhuzhuangtu",
					text: "柱形图",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "60",
					icon: "iconfont icon-xingzhuang-tupian",
					text: "图片",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "61",
					icon: "iconfont icon-xingzhuang-wenzi",
					text: "文字",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "62",
					icon: "iconfont icon-xingzhuang-tuoyuanxing",
					text: "椭圆形",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "63",
					icon: "iconfont icon-xingzhuang-sanjiaoxing",
					text: "三角形",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "64",
					icon: "iconfont icon-xingzhuang-xingxing",
					text: "星形",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "65",
					icon: "iconfont icon-guize",
					text: "规则",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "66",
					icon: "iconfont icon-shebeiguanli",
					text: "设备管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "67",
					icon: "iconfont icon-gongnengdingyi1",
					text: "功能定义",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "68",
					icon: "iconfont icon-jishufuwu1",
					text: "技术服务",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "69",
					icon: "iconfont icon-yunyingzhongxin",
					text: "运营中心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "70",
					icon: "iconfont icon-yunyingguanli",
					text: "运营管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "71",
					icon: "iconfont icon-zuzhixiaxia",
					text: "组织下辖",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "72",
					icon: "iconfont icon-zuzhizhankai",
					text: "组织展开",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "73",
					icon: "iconfont icon-zuzhiqunzu",
					text: "组织群组",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "74",
					icon: "iconfont icon-dakai",
					text: "打开",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "75",
					icon: "iconfont icon-yingwen",
					text: "英文",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "76",
					icon: "iconfont icon-zhongwen",
					text: "中文",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "77",
					icon: "iconfont icon-miwen",
					text: "密文",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "78",
					icon: "iconfont icon-xianhao",
					text: "显号",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "79",
					icon: "iconfont icon-kongxinduigou",
					text: "空心对勾",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "80",
					icon: "iconfont icon-huixingzhen",
					text: "回形针",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "81",
					icon: "iconfont icon-duigou",
					text: "对勾",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "82",
					icon: "iconfont icon-xiayibu",
					text: "下一步",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "83",
					icon: "iconfont icon-shangyibu",
					text: "上一步",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "84",
					icon: "iconfont icon-kongjianxuanzhong",
					text: "控件选中",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "85",
					icon: "iconfont icon-kongjianweixuan",
					text: "控件未选",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "86",
					icon: "iconfont icon-kongjianyixuan",
					text: "控件已选",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "87",
					icon: "iconfont icon--diangan",
					text: "电杆",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "88",
					icon: "iconfont icon-rongxuejirongjiechi",
					text: "融雪剂溶解池",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "89",
					icon: "iconfont icon-lubiantingchechang",
					text: "路边停车场",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "90",
					icon: "iconfont icon--lumingpai",
					text: "路名牌",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "91",
					icon: "iconfont icon-jietouzuoyi",
					text: "街头座椅",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "92",
					icon: "iconfont icon--zhongdaweixian",
					text: "重大危险",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "93",
					icon: "iconfont icon--jiaotongbiaozhipai",
					text: "交通标志牌",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "94",
					icon: "iconfont icon-gongcezhishipai",
					text: "公厕指示牌",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "95",
					icon: "iconfont icon-fangkuai",
					text: "方块加",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "96",
					icon: "iconfont icon-fangkuai-",
					text: "方块减",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "97",
					icon: "iconfont icon-shuaxin",
					text: "刷新",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "98",
					icon: "iconfont icon-baocun",
					text: "保存",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "99",
					icon: "iconfont icon-fabu",
					text: "发布",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "100",
					icon: "iconfont icon-xiayibu1",
					text: "下一步",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "101",
					icon: "iconfont icon-shangyibu1",
					text: "上一步",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "102",
					icon: "iconfont icon-xiangxiazhanhang",
					text: "向下占行",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "103",
					icon: "iconfont icon-xiangshangzhanhang",
					text: "向上占行",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "104",
					icon: "iconfont icon-tupianjiazaishibai",
					text: "图片加载失败",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "105",
					icon: "iconfont icon-fuwudiqiu",
					text: "服务地球",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "106",
					icon: "iconfont icon-suoxiao",
					text: "缩小",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "107",
					icon: "iconfont icon-fangda",
					text: "放大",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "108",
					icon: "iconfont icon-huanyuanhuabu",
					text: "还原画布",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "109",
					icon: "iconfont icon-quanping",
					text: "全屏",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "110",
					icon: "iconfont icon-biaodanzujian-biaoge1",
					text: "表格",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "111",
					icon: "iconfont icon-APIshuchu",
					text: "API输出",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "112",
					icon: "iconfont icon-APIjieru",
					text: "API接入",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "113",
					icon: "iconfont icon-wenjianjia",
					text: "文件夹",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "114",
					icon: "iconfont icon-DOC",
					text: "DOC",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "115",
					icon: "iconfont icon-BMP",
					text: "BMP",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "116",
					icon: "iconfont icon-GIF",
					text: "GIF",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "117",
					icon: "iconfont icon-JPG",
					text: "JPG",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "118",
					icon: "iconfont icon-PNG",
					text: "PNG",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "119",
					icon: "iconfont icon-weizhigeshi",
					text: "未知格式",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "120",
					icon: "iconfont icon-gengduo",
					text: "更多",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "121",
					icon: "iconfont icon-yunduanxiazai",
					text: "云端下载",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "122",
					icon: "iconfont icon-yunduanshangchuan",
					text: "云端上传",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "123",
					icon: "iconfont icon-dian",
					text: "点",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "124",
					icon: "iconfont icon-mian",
					text: "面",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "125",
					icon: "iconfont icon-xian",
					text: "线",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "126",
					icon: "iconfont icon-shebeizhuangtai",
					text: "设备状态",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "127",
					icon: "iconfont icon-fenzuguanli",
					text: "分组管理",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "128",
					icon: "iconfont icon-kuaisubianpai",
					text: "快速编排",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "129",
					icon: "iconfont icon-APPkaifa",
					text: "APP开发",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "130",
					icon: "iconfont icon-wentijieda",
					text: "问题解答",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "131",
					icon: "iconfont icon-kefu",
					text: "客服",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "132",
					icon: "iconfont icon-ruanjiankaifabao",
					text: "软件开发包",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "133",
					icon: "iconfont icon-sousuobianxiao",
					text: "搜索变小",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "134",
					icon: "iconfont icon-sousuofangda",
					text: "搜索放大",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "135",
					icon: "iconfont icon-dingwei",
					text: "定位",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "136",
					icon: "iconfont icon-wumoxing",
					text: "物模型",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "137",
					icon: "iconfont icon-gaojing",
					text: "告警",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "138",
					icon: "iconfont icon-renwujincheng",
					text: "任务进程",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "139",
					icon: "iconfont icon-xiaoxitongzhi",
					text: "消息警告",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "140",
					icon: "iconfont icon-youhui",
					text: "优惠",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "141",
					icon: "iconfont icon-gaojing1",
					text: "告警",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "142",
					icon: "iconfont icon-zhihangfankui",
					text: "执行反馈",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "143",
					icon: "iconfont icon-gongdanqueren",
					text: "工单确认",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "144",
					icon: "iconfont icon-guangbo",
					text: "广播",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "145",
					icon: "iconfont icon-gongdan",
					text: "工单",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "146",
					icon: "iconfont icon-xiaoxi",
					text: "消息",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "147",
					icon: "iconfont icon-ditu-qi",
					text: "旗",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "148",
					icon: "iconfont icon-ditu-dibiao",
					text: "地标",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "149",
					icon: "iconfont icon-ditu-cha",
					text: "叉",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "150",
					icon: "iconfont icon-ditu-qipao",
					text: "气泡",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "151",
					icon: "iconfont icon-ditu-tuding",
					text: "图钉",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "152",
					icon: "iconfont icon-ditu-huan",
					text: "环",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "153",
					icon: "iconfont icon-ditu-xing",
					text: "星",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "154",
					icon: "iconfont icon-ditu-yuan",
					text: "圆",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "155",
					icon: "iconfont icon-chehuisekuai",
					text: "撤回色块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "156",
					icon: "iconfont icon-shanchusekuai",
					text: "删除色块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "157",
					icon: "iconfont icon-fabusekuai",
					text: "发布色块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "158",
					icon: "iconfont icon-xinhao",
					text: "信号",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "159",
					icon: "iconfont icon-lanya",
					text: "蓝牙",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "160",
					icon: "iconfont icon-Wi-Fi",
					text: "WI-FI",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "161",
					icon: "iconfont icon-chaxun",
					text: "查询",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "162",
					icon: "iconfont icon-dianbiao",
					text: "电表",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "163",
					icon: "iconfont icon-anquan",
					text: "安全",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "164",
					icon: "iconfont icon-daibanshixiang",
					text: "待办事项",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "165",
					icon: "iconfont icon-bingxiang",
					text: "冰箱",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "166",
					icon: "iconfont icon-fanshe",
					text: "反射",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "167",
					icon: "iconfont icon-fengche",
					text: "风车",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "168",
					icon: "iconfont icon-guandao",
					text: "管道",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "169",
					icon: "iconfont icon-guize1",
					text: "规则",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "170",
					icon: "iconfont icon-guizeyinqing",
					text: "规则引擎",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "171",
					icon: "iconfont icon-huowudui",
					text: "货物堆",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "172",
					icon: "iconfont icon-jianceqi",
					text: "检测器",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "173",
					icon: "iconfont icon-jinggai",
					text: "井盖",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "174",
					icon: "iconfont icon-liujisuan",
					text: "流计算",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "175",
					icon: "iconfont icon-hanshu",
					text: "函数",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "176",
					icon: "iconfont icon-lianjieliu",
					text: "连接流",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "177",
					icon: "iconfont icon-ludeng",
					text: "路灯",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "178",
					icon: "iconfont icon-shexiangji",
					text: "摄像头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "179",
					icon: "iconfont icon-rentijiance",
					text: "人脸检测",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "180",
					icon: "iconfont icon-moshubang",
					text: "魔术棒",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "181",
					icon: "iconfont icon-shujuwajue",
					text: "数据挖掘",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "182",
					icon: "iconfont icon-wangguan",
					text: "网关",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "183",
					icon: "iconfont icon-shenjing",
					text: "人脑",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "184",
					icon: "iconfont icon-chucun",
					text: "存储",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "185",
					icon: "iconfont icon-wuguan",
					text: "AI",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "186",
					icon: "iconfont icon-yunduanshuaxin",
					text: "云端刷新",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "187",
					icon: "iconfont icon-yunhang",
					text: "运行",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "188",
					icon: "iconfont icon-luyouqi",
					text: "路由器",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "189",
					icon: "iconfont icon-bug",
					text: "Bug",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "190",
					icon: "iconfont icon-get",
					text: "Get",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "191",
					icon: "iconfont icon-PIR",
					text: "PIR",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "192",
					icon: "iconfont icon-zhexiantu",
					text: "折线图",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "193",
					icon: "iconfont icon-shuibiao",
					text: "水表",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "194",
					icon: "iconfont icon-js",
					text: "JS",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "195",
					icon: "iconfont icon-zihangche",
					text: "自行车",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "196",
					icon: "iconfont icon-liebiao",
					text: "列表",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "197",
					icon: "iconfont icon-qichedingwei",
					text: "汽车定位",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "198",
					icon: "iconfont icon-dici",
					text: "地磁",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "199",
					icon: "iconfont icon-mysql",
					text: "MySql",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "200",
					icon: "iconfont icon-qiche",
					text: "汽车",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "201",
					icon: "iconfont icon-shenjing1",
					text: "神经",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "202",
					icon: "iconfont icon-chengshi",
					text: "城市",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "203",
					icon: "iconfont icon-tixingshixin",
					text: "告警实心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "204",
					icon: "iconfont icon-menci",
					text: "门磁",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "205",
					icon: "iconfont icon-chazuo",
					text: "插座",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "206",
					icon: "iconfont icon-ranqijianceqi",
					text: "燃气检测",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "207",
					icon: "iconfont icon-kaiguan",
					text: "开关",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "208",
					icon: "iconfont icon-chatou",
					text: "插头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "209",
					icon: "iconfont icon-xiyiji",
					text: "洗衣机",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "210",
					icon: "iconfont icon-yijiankaiguan",
					text: "一键开关",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "211",
					icon: "iconfont icon-yanwubaojingqi",
					text: "烟雾报警器",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "212",
					icon: "iconfont icon-wuxiandianbo",
					text: "无限电波",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "213",
					icon: "iconfont icon-fuzhi",
					text: "复制",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "214",
					icon: "iconfont icon-shanchu",
					text: "删除",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "215",
					icon: "iconfont icon-bianjisekuai",
					text: "编辑色块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "216",
					icon: "iconfont icon-ishipinshixiao",
					text: "视频失效",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "217",
					icon: "iconfont icon-iframetianjia",
					text: "ifram添加",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "218",
					icon: "iconfont icon-tupiantianjia",
					text: "图片添加",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "219",
					icon: "iconfont icon-liebiaomoshi_kuai",
					text: "列表模式_块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "220",
					icon: "iconfont icon-qiapianmoshi_kuai",
					text: "卡片模式_块",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "221",
					icon: "iconfont icon-fenlan",
					text: "分栏",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "222",
					icon: "iconfont icon-fengexian",
					text: "分割线",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "223",
					icon: "iconfont icon-dianzan",
					text: "点赞",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "224",
					icon: "iconfont icon-charulianjie",
					text: "插入链接",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "225",
					icon: "iconfont icon-charutupian",
					text: "插入图片",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "226",
					icon: "iconfont icon-quxiaolianjie",
					text: "取消链接",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "227",
					icon: "iconfont icon-wuxupailie",
					text: "无序列表",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "228",
					icon: "iconfont icon-juzhongduiqi",
					text: "居中对齐",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "229",
					icon: "iconfont icon-yinyong",
					text: "引用",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "230",
					icon: "iconfont icon-youxupailie",
					text: "有序列表",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "231",
					icon: "iconfont icon-youduiqi",
					text: "右对齐",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "232",
					icon: "iconfont icon-zitidaima",
					text: "字体代码",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "233",
					icon: "iconfont icon-xiaolian",
					text: "笑脸",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "234",
					icon: "iconfont icon-zitijiacu",
					text: "字体加粗",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "235",
					icon: "iconfont icon-zitishanchuxian",
					text: "字体删除线",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "236",
					icon: "iconfont icon-zitishangbiao",
					text: "字体上标",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "237",
					icon: "iconfont icon-zitibiaoti",
					text: "字体标题",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "238",
					icon: "iconfont icon-zitixiahuaxian",
					text: "字体下划线",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "239",
					icon: "iconfont icon-zitixieti",
					text: "字体斜体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "240",
					icon: "iconfont icon-zitiyanse",
					text: "字体颜色",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "241",
					icon: "iconfont icon-zuoduiqi",
					text: "左对齐",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "242",
					icon: "iconfont icon-zitiyulan",
					text: "字体预览",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "243",
					icon: "iconfont icon-zitixiabiao",
					text: "字体下标",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "244",
					icon: "iconfont icon-zuoyouduiqi",
					text: "左右对齐",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "245",
					icon: "iconfont icon-tianxie",
					text: "编辑",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "246",
					icon: "iconfont icon-huowudui1",
					text: "集成打包",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "247",
					icon: "iconfont icon-yingjian",
					text: "硬件",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "248",
					icon: "iconfont icon-shebeikaifa1",
					text: "设备开发",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "249",
					icon: "iconfont icon-dianzan_kuai",
					text: "点赞",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "250",
					icon: "iconfont icon-zhihuan",
					text: "置换",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "251",
					icon: "iconfont icon-tuoguan",
					text: "托管",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "252",
					icon: "iconfont icon-duigoux",
					text: "对勾",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "253",
					icon: "iconfont icon-guanbi1",
					text: "关闭",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "254",
					icon: "iconfont icon-aixin_shixin",
					text: "实心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "255",
					icon: "iconfont icon-ranqixieloubaojingqi",
					text: "燃气泄漏报警器",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "256",
					icon: "iconfont icon-dianbiao_shiti",
					text: "电表_实体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "257",
					icon: "iconfont icon-aixin",
					text: "爱心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "258",
					icon: "iconfont icon-shuibiao_shiti",
					text: "水表_实体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "259",
					icon: "iconfont icon-zhinengxiaofangshuan",
					text: "只能消防栓",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "260",
					icon: "iconfont icon-ranqibiao_shiti",
					text: "燃气表_实体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "261",
					icon: "iconfont icon-shexiangtou_shiti",
					text: "摄像头_实体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "262",
					icon: "iconfont icon-shexiangtou_guanbi",
					text: "摄像头_关闭",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "263",
					icon: "iconfont icon-shexiangtou",
					text: "摄像头",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "264",
					icon: "iconfont icon-shengyin_shiti",
					text: "声音_实体",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "265",
					icon: "iconfont icon-shengyinkai",
					text: "声音开",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "266",
					icon: "iconfont icon-shoucang_shixin",
					text: "收藏_实心",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "267",
					icon: "iconfont icon-shoucang",
					text: "收藏",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "268",
					icon: "iconfont icon-shengyinwu",
					text: "声音无",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "269",
					icon: "iconfont icon-shengyinjingyin",
					text: "声音静音",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "270",
					icon: "qqqqqqwwwww",
					text: "wwwwwwqqqqq",
				},
				{
					delFlag: 1,
					createTime: "2020-04-23 15:45:59",
					updateDate: "2020-04-23 15:45:59",
					id: "271",
					icon: "rrrrrrppppp",
					text: "pppppprrrrr",
				},
			],
			selectLang: [],
			loading: false,
			loadingForm: false,
			itemKey: "",
			labelPosition: "top",
			clear: false,
			rules: {
				path: [
					{
						required: true,
						message: this.$t("addMenu.rPath"),
						target: "blur",
						pattern: "^[/][a-zA-Z/]+$",
					},
				],
				component: [
					{
						required: true,
						message: this.$t("addMenu.rComponent"),
						target: "blur",
						pattern: "^[A-Z][a-zA-Z]",
					},
				],
				icon: [
					{
						required: true,
						message: this.$t("addMenu.rIcon"),
						target: "blur",
					},
				],
				authority: [
					{
						required: true,
						message: this.$t("addMenu.rAuthority"),
						target: "blur",
						pattern: "^[a-z][a-z:]+$",
					},
				],
				url: [
					{
						required: true,
						message: this.$t("addMenu.rMenuUrl"),
						target: "blur",
						pattern: "^[/][a-zA-Z/]+[a-zA-Z\\*]$",
					},
				],
			},
		};
	},
	props: {
		dialogAddMenu: Boolean,
		isMenuProp: Boolean,
		nodeData: Object,
		menuList: Array,
		selectId: String,
		langList: Array,
	},
	methods: {
		handleClose() {
			this.closeDialogAddMenu();
		},

		closeDialogAddMenu() {
			this.$emit("closeDialogAddMenu", false);
		},

		addMenu(menu) {
			this.$refs[menu].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.AuthorityMenu.update;
					let method = this.$method.put;
					if (!this.nodeData.id) {
						// 添加菜单
						this.nodeData.pId = this.nodeData.id;
						this.nodeData.id = "";
						url = this.$url.AuthorityMenu.insert;
						method = this.$method.post;
					}
					this.nodeData.pId = this.selectId;
					this.$api
						.request(url, method, this.nodeData)
						.then(res => {
							if (res.code === 0) {
								this.$emit(
									"updateMenu",
									this.nodeData.id
										? this.$t("addMenu.upS")
										: this.$t("addMenu.addS")
								);
								this.clear = true;
								// this.closeDialogAddMenu();
							}
							this.loadingForm = false;
						})
						.catch(() => {
							this.$message.warning(
								this.nodeData.id
									? this.$t("addMenu.addE")
									: this.$t("addMenu.upE")
							);
							this.loadingForm = false;
						});
				} else {
					return false;
				}
			});
		},

		open() {
			this.clearVal("menuData");
			this.langList.forEach(k => {
				k["disabled"] = k.value === this.nodeData.names[0].lang;
			});
			if (this.nodeData.id) {
				this.loading = true;
				this.$api
					.request(this.$url.AuthorityMenu.listMenuName, this.$method.get, {
						menuId: this.nodeData.id,
					})
					.then(res => {
						if (res.code === 0) {
							if (res.data.length > 0) {
								this.nodeData.names = res.data;
								this.langList.forEach(k => {
									res.data.forEach(d => {
										if (k.value === d.lang) {
											k["disabled"] = true;
										}
									});
								});
							} else {
								this.setLang();
							}
						}
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
			}
		},

		closed() {
			if (this.nodeData.id) {
				this.$toolUtil.clearForm(this.nodeData);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.nodeData);
				}
			}
		},

		addIcon(icon) {
			this.visible = !this.visible;
			this.nodeData.icon = icon;
		},

		clearVal(formName) {
			this.$nextTick(() => {
				this.$refs[formName].clearValidate();
			});
		},

		addLang() {
			if (this.nodeData.names.length >= this.langList.length) {
				this.$message.warning("添加语言超出上限");
			} else {
				this.setLang();
			}
		},

		delLang(item) {
			let index = this.nodeData.names.indexOf(item);
			if (index !== -1) {
				this.nodeData.names.splice(index, 1);
			}
			if (item.lang) {
				for (let i = 0; i < this.langList.length; i++) {
					if (this.langList[i].value === item.lang) {
						this.langList[i]["disabled"] = false;
						this.itemKey = Math.random();
						break;
					}
				}
			}
		},

		setLang() {
			for (let i = 0; i < this.langList.length; i++) {
				if (!this.langList[i].disabled) {
					this.nodeData.names.push({
						lang: this.langList[i].value,
						name: "",
						key: Date.now(),
					});
					this.langList[i]["disabled"] = true;
					break;
				}
			}
		},

		changeMenu() {
			let arr = [];
			this.nodeData.names.forEach(k => {
				if (k.lang) {
					arr.push(k.lang);
				}
			});
			this.langList.forEach(k => {
				k["disabled"] = false;
			});
			arr.forEach(k => {
				this.langList.forEach(g => {
					if (k === g.value) {
						g["disabled"] = true;
					}
				});
			});
		},
	},
	mounted() {},
};
</script>

<style lang="scss">
// ::v-deep .el-dialog__body {
// 	height: auto !important;
// }
.vue-treeselect__placeholder {
	line-height: 40px;
	padding: 0 10px;
}

.vue-treeselect__single-value {
	padding: 0 10px;
	line-height: 40px;
}

.add-menu .el-select .el-input {
	width: 130px;
}
.add-menu .add-lang .el-form-item__content {
	margin-left: 0 !important;
}
.add-menu .add-lang {
	.btn {
		width: 100%;
		border-radius: 4px;
		text-align: center;
		cursor: pointer;
		margin-top: 50px;
	}
	.add-btn {
		border: 1px dashed #409eff;
		color: #409eff;
	}
	.del-btn {
		border: 1px dashed #f56c6c;
		color: #f56c6c;
	}
}
.add-menu .menu-scroll {
	max-height: 200px;
	overflow-y: scroll;
	overflow-x: hidden;
}

.popper-icon {
	padding: 12px !important;
}

.popper-icon .icon-picker-scroll {
	max-height: 280px;
	overflow-y: auto;
	overflow-x: hidden;
}

.popper-icon .icon-menu-list {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
	gap: 8px;
}

.popper-icon .icon-menu-list li {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 48px;
	border: 1px solid #e4e7ed;
	border-radius: 8px;
	background: #fff;
	cursor: pointer;
	transition: border-color 0.2s ease, color 0.2s ease, background-color 0.2s ease;
}

.popper-icon .icon-menu-list li:hover {
	color: #409eff;
	border-color: #409eff;
	background: #ecf5ff;
}

.popper-icon .icon-menu-list i {
	font-size: 20px;
	line-height: 1;
}
</style>
